import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListCancellationPolicies from "../Components/CancellationPolicies/list";
import AddCancellationPolicy from "../Components/CancellationPolicies/add";
import ViewCancellationPolicy from "../Components/CancellationPolicies/view";
import UpdateCancellationPolicy from "../Components/CancellationPolicies/edit";

const CancellationPoliciesRoutes = () => {

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');


  return (
    <Routes>
      <Route
        path="/cancellation_policies"
        element={<ListCancellationPolicies></ListCancellationPolicies>}
      ></Route>
      <Route
        path="/cancellation_policies/add"
        element={canAdd ? <AddCancellationPolicy /> : <Navigate to="/cancellation_Policies" replace />}
      ></Route>
      <Route
        path="/cancellation_policies/view/:id"
        element={<ViewCancellationPolicy></ViewCancellationPolicy>}
      ></Route>
      <Route
        path="/cancellation_policies/edit/:id"
        element={canEdit ? <UpdateCancellationPolicy></UpdateCancellationPolicy> : <Navigate to="/cancellation_Policies" replace />}
      ></Route>
    </Routes>
  );
};

export default CancellationPoliciesRoutes;
